<div class="patient-certification-container">
    <div class="patient-certification-search">
        <form (keyup.enter)="onSearch()">
            <mat-form-field appearance="outline">
                <mat-label translate>{{ "LastName" | translate }}</mat-label>
                <input
                    [(ngModel)]="patientToSearch.lastName"
                    name="lastName"
                    matInput
                    [placeholder]="'LastName' | translate"
                />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label translate>{{ "FirstName" | translate }}</mat-label>
                <input
                    [(ngModel)]="patientToSearch.firstName"
                    name="firstName"
                    matInput
                    [placeholder]="'FirstName' | translate"
                />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label translate>{{ "Sex" | translate }}</mat-label>
                <mat-select
                    [compareWith]="compareIds"
                    [placeholder]="'Sex' | translate"
                    [(ngModel)]="patientToSearch.sex"
                    name="sex"
                    [disableOptionCentering]="true"
                >
                    <mat-option
                        *ngFor="let sex of sexes"
                        [value]="sex"
                        matTooltipPosition="right"
                        matTooltipShowDelay="1000"
                    >
                        {{ sex.description }}
                    </mat-option>
                </mat-select>
                <button matSuffix mat-icon-button type="button" (click)="onResetSex()" tabIndex="-1">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label translate>{{ "TaxCode" | translate }}</mat-label>
                <input
                    matInput
                    [placeholder]="'TaxCode' | translate"
                    [(ngModel)]="patientToSearch.taxCode"
                    name="taxCode"
                />
            </mat-form-field>
            <!--<mat-form-field>
                <input matInput [placeholder]="'BirthDate' | translate" #birthDate>
            </mat-form-field>-->
            <mat-form-field class="se-date-input" appearance="outline">
                <mat-label class="se-date-label" translate>{{ "BirthDate" | translate }}</mat-label>
                <input
                    [(ngModel)]="patientToSearch.birthDate"
                    name="birthDate"
                    matInput
                    [placeholder]="'BirthDate' | translate"
                    [matDatepicker]="picker"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <button matPrefix mat-icon-button type="button" (click)="onResetDate()" tabIndex="-1">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <button mat-icon-button [class.patient-certification-part-disabled]="loading" (click)="onSearch()">
                <mat-icon *ngIf="!loading">search</mat-icon>
                <mat-icon *ngIf="loading">hourglass_empty</mat-icon>
            </button>
        </form>
    </div>
    <div class="grid-container">
        <ag-grid-angular
            #datagrid
            class="worklist-grid"
            [gridOptions]="gridOptions"
            [rowData]="items"
            (selectionChanged)="onSelectionChange($event)"
            [loading]="false"
            [modules]="agGridModuls"
            [theme]="agGridTheme"
        >
        </ag-grid-angular>
    </div>
    <div class="patient-certification-message" *ngIf="message">
        <label>{{ message }}</label>
    </div>
    <div class="patient-certification-buttons">
        <button mat-button [class.patient-certification-part-disabled]="!canCertificate()" (click)="onCertificate()">
            <p translate>ECG_CertificatePatient</p>
        </button>
        <!--<button mat-button [class.patient-certification-part-disabled]="!canImport()" (click)="importAndCertificateStream$.next()">
            <p translate>ECG_ImportAndCertificatePatient</p>
        </button>-->
        <button mat-button (click)="onClose(false)">
            <p translate>Cancel</p>
        </button>
    </div>
</div>
